import { sendRequest } from '../../config';

export interface topesTratamientosParams {
    cpais: string;
    cciaseg: string;
    ccliente: string;
    cplan: string;
    ccedaseg: string;
    cdiagnos: string;
    ctrata: string;
    fcita: string;
    fdesde_pol: string;
    fhasta_pol: string;
}

export interface dataTopesTratamientos {
    mensaje: string;
    codigo_error: string;
    supera_tope: number;
    fproximacita?: string;
    tope_aplicado?: string ;
    frecuencia_aplicada?: string;
    tipo_tope?: string ;
    mensaje_conjunto?: string ;
}

export const topesTratamientos = async (params: topesTratamientosParams): Promise<dataTopesTratamientos> => {
    const ENDPOINT = 'v2/topes/tratamientos';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};